import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import LineReceptionComponent from '../../../components/lineReception/sp/lineReceptionComponent';
import { getLineReceptionList } from '../../../store/line/getLineReceptionListSlice';
import customerPostLineReceptionsApi from '../../../apis/customer/customerPostLineReceptionsApi';

function LineReceptionContainer() {
  const dispatch = useDispatch();
  const lineReceptions = useSelector((state) => state.receptionList.responseParams) ?? [];

  useEffect(() => {
    const fetchCustomers = async () => {
      const params = {
        customerIds: [],
        offset: 0,
        isOwnCustomers: 1,
      };
      const list = await customerPostLineReceptionsApi(params);
      dispatch(getLineReceptionList(list));
    };

    fetchCustomers();
  }, [dispatch]);

  return <LineReceptionComponent lineReceptions={lineReceptions} />;
}

export default LineReceptionContainer;
